import React, {useState, useEffect} from "react";
import ReactModal from "react-modal";

export default function DetailModal(props) {
    const [width, setWidth] = useState(window.innerWidth);
    const breakpoint = 600;
    
    useEffect(() => {
        window.addEventListener("resize", () => setWidth(window.innerWidth))
    }, []);
    
    var selectedGame = props.selectedGame;
    var reportingGame = props.reportingGame;
    return (<ReactModal
        isOpen={selectedGame !== null && !reportingGame}
        onRequestClose={() => props.setSelectedGame(null)}
        shouldCloseOnOverlayClick={true}
        style={{
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                zIndex:1000
            },
            content: {
                backgroundColor: '#0f0f0f',
                border: 'none',
                minWidth: '50%',
                minHeight: '40%',
                inset: width > breakpoint ? '25%' : '25% 5% 25% 5%',
                alignContent: 'center',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
            }
        }}
    >
        {selectedGame !== null && <div style={{textAlign: 'center'}}>
            <button
                style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    fontSize: '40px',
                    boxShadow: 'none',
                    padding: '0',
                    lineHeight: '32px',
                    height: '35px',
                }}
                onClick={() => props.setSelectedGame(null)}
            >
                X
            </button>
            <h2 style={{textAlign: 'center'}}>{selectedGame.name}</h2>
            <p style={{textAlign: 'center'}}>{selectedGame.notes ? selectedGame.notes : selectedGame.compatible === 1 || selectedGame.compatible === 3 ? "Has known issues that may make game unplayable" :  selectedGame.compatible === 2 ? "Requires Secure Boot be disabled to work" : selectedGame.compatible === 4 ? "Works best with OpenXR Runtime set to VDXR" : "No Known Issues"}</p>
            <div style={{width: '80%', display: 'inline-block'}}>
                <a href={selectedGame.store} target='_blank' className="button primary fit">Open Store Page</a>
                <a href='#' className="button fit" onClick={(e) => props.startGameReport()}>Report Compatibility Issue</a>
            </div>
        </div>}
    </ReactModal>)
}